import React, { useContext } from 'react';
import styled from 'styled-components';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  display: flex;
  margin-top: 30px;
  justify-content: space-between;
  @media (max-width: 789px) {
    flex-wrap: wrap;
  }
  a {
    background: #F1A857;
    border-radius: 3px;
    height: 70px;
    display: block;
    width: 48%;
    display: flex;
    align-items: center;
    text-decoration: none;
    transition: all 0.3s;
    @media (max-width: 789px) {
      width: 100%;
      margin-bottom: 10px;
    }
    &:hover {
      background: #E59134;
      .icone {
        border-right: 1px solid #CD8226;
      }
    }
    .icone {
      border-right: 1px solid #E0933D;
      width: 78px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      margin-right: 20px;
      i {
        height: 30px;
        width: 30px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        &.layers { 
          background-image: url(/images/streamline-icon-layers@140x140@2x.png);
        }
        &.pin {
          background-image: url(/images/streamline-icon-earth-pin-2@140x140@2x.png);
        }
      }
    }
    .texto {
      align-items: center;
      display: flex;
      font-size: 16px;
      color: #FFFFFF;
      letter-spacing: 0.36px;
    }
  }
`;

const Buttons = ({amostra, onde_encontrar}) => {
  const { language } = useContext(LanguageContext);
  let ondeEncontrar = ''
  let amostraText = ''
  switch (language) {
    case 'pt-br':
      ondeEncontrar = 'Onde encontrar';
      amostraText = 'Amostra';
      break;
    case 'en-us':
      ondeEncontrar = 'Where to find';
      amostraText = 'Sample';
      break;
    case 'es-es':
      ondeEncontrar = 'Donde encontrar';
      amostraText = 'Muestra';
      break;
    default:
  }
  return (
    <Container>
      {
        amostra.url && (
          <a href={ amostra.url } target="_blank" rel="noopener noreferrer">
            <span className="icone">
              <i className="pin"></i>
            </span>
            <span className="texto">
              { ondeEncontrar }
            </span>
          </a>
        )
      }
      {
        onde_encontrar.url && (
          <a href={ onde_encontrar.url } target="_blank" rel="noopener noreferrer">
            <span className="icone">
              <i className="layers"></i>
            </span>
            <span className="texto">
              { amostraText }
            </span>
          </a>
        )
      }
    </Container>
  );
}

export default Buttons;
